import { concat, Observable, of } from 'rxjs';
import { Action } from 'redux';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { mergeMap } from 'rxjs';
import { StorageActions, StorageMsg } from 'src/core/engine/storage/storage.actions';

import { STORAGE_KEY, CspActions } from '../csp.register';

export function cpsSignOut(action$: Observable<any>): Observable<Action> {
    const signOut$ = action$.pipe(ofType<CspActions>('Csp.SignOut'));
    /**
     * Merge the streams to perform the sign-out on both
     */
    return signOut$.pipe(
        mergeMap(() => {
            return concat(
                of(StorageMsg(StorageActions.Delete, STORAGE_KEY), StorageMsg(StorageActions.Delete, 'cspCustomer')),
            );
        }),
    );
}
